import { useMemo } from "react";

import { useMatchesWithCrumb } from "@phoenix/hooks/useMatchesWithCrumb";

export function NavTitle() {
  const matchesWithCrumb = useMatchesWithCrumb();

  const titleText = useMemo(() => {
    const crumbText = matchesWithCrumb
      .map((match) => match.handle.crumb(match.loaderData))
      .reverse()
      .join(" - ");
    return crumbText ? `${crumbText} - Evalight` : "Evalight";
  }, [matchesWithCrumb]);
  return <title>{titleText}</title>;
}
